import React from 'react'
import CategoryList from './categoryList'

function HomePage() {
    return (
        <>
            <CategoryList />
        </>
    )
}

export default HomePage